import { Component, effect } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Parcel } from '../../shared/models/parcel';
import { ParcelService } from '../../shared/services/parcel.service';
import { DataService } from '../../shared/services/data.service';
import { environment as env } from '../../../environments/environment';
import { TablePageEvent } from 'primeng/table';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { ParcelDetailComponent } from "../parcel-detail/parcel-detail.component";
import { DashboardFiltersComponent } from "../dashboard-filters/dashboard-filters.component";



@Component({
  selector: 'app-allassigned',
  templateUrl: './allassigned.component.html',
  styleUrl: './allassigned.component.scss',
  standalone:true,
  imports: [...PRIMENG_MODULES, SpinnerComponent, ParcelDetailComponent, DashboardFiltersComponent]
})
export class AllassignedComponent {

  recordNotFound = false;
  sortOptions!: SelectItem[];
  sortOrder!: number;
  selectedParcel: Parcel[] = [];
  users: string[] = [];
  BulkUsersList: string[] = [];
  sortField!: string;
  checked: boolean = false;
  selectedUser: string | undefined;
  data: any;
  updater: string | undefined;
  displayDialog: boolean = false;
  isLoading: boolean = false;
  bulkUpdateLimit: number = env.bulkUpdateLimit;
  bulkUpdateUserId: string = '';
  cameraList = this.parcelService.getCameraList();

  parcel: any[] = [];
  selectedRow: Parcel[] = [];
  dateRange: any;
  selectedCamera: string = ''
  selectedItemCode: string = ''
  itemCodes = this.parcelService.getItemCodes();
  filterOptions = {
    showCameraFilter: true,
    showItemCodeFilter: true,
    showDateRangeFilter: true,
    showApplyButton: true,
    showClearFilterButton: true,
    showSearchParcel: true,
    showUserIdFilter: true
  }
  selectedUserForFilter: string = '';
  searchParcel: string = '';

  singleSelections = true;
  itemsFromSingleSelections: any[] = [];
  isAdmin: boolean = false;
  rowsPerPage: any;
  enableClose: boolean = true;

  undoParcelDetails: any = {};
  private timerId: any;
  readonly INITIAL_TIME = 10
  timeLeft: number = this.INITIAL_TIME;

  constructor(private parcelService: ParcelService,
    private dataService: DataService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    effect(() => {
      this.updater = this.dataService.currentDataSignal();
    });

  }

  ngOnInit() {
    this.isLoading = true;
    this.getUserDetails();
    this.getAssigned();
    this.isAdmin = this.parcelService.isAdmin();
  }

  getUserDetails() {
    this.parcelService.getUsers().subscribe(
      result => {
        this.isLoading = false;
        this.users = result.users;
        this.BulkUsersList = [...result.users];
        this.BulkUsersList.sort((a,b)=>{
          if (a === this.updater) return -1;
          if (b === this.updater) return 1;
          return a.localeCompare(b);
        })
      }
    )

  }

  getAssigned(queryParam = '') {
    this.parcel = [];
    this.parcelService.getAllAssigned(queryParam).subscribe(

      result => {

        this.parcel = result.data;
        this.parcel = this.parcel.map(item => ({
          ...item,
          cameraName: this.cameraList.find(cam =>
            cam.value != null &&
            cam.value == item['capturedevice-id'])?.label
        }));

        this.isLoading = false;
      }
    )

  }

  onParcelClick(row: any) {
    this.recordNotFound = false;
    this.selectedRow = row;
    this.displayDialog = true;
  }

  handleRecordNotFound() {
    this.recordNotFound = true;
  }

  resetModalState() {
    this.selectedRow = [];
    this.recordNotFound = false;
  }

  onItemClick(event: MouseEvent, parcel: any): void {
    event.preventDefault();
  }


  onApiSuccessFromModal(data:any) {
    
    this.refreshData();
    this.displayDialog = false;
    this.undoParcelDetails = data;
    this.displayDialog = false;
    if (data.status === 'handled') {
      this.messageService.add({
        key: 'actionToast',
        severity: 'success',
        summary: 'Success',
        detail: "Item is Handled",
        life: 300000,
      });
      this.startCountdown();
    }
  }

  private refreshData(): void {
    this.isLoading = true;
    this.selectedParcel = [];

    this.parcel = [];
    this.getAssigned();
    this.isLoading = false;
    this.itemsFromSingleSelections = [];
  }

  private resetBulkId(): void {
    this.bulkUpdateUserId = '';
    this.selectedParcel = [];
    this.itemsFromSingleSelections = [];
  }
  receiveFilterApplied(params: any) {
    this.selectedCamera = params.selectedCamera;
    this.selectedItemCode = params.selectedItemCode;
    this.dateRange = params.dateRange;
    this.selectedUserForFilter = params.selectedUser;
    this.searchParcel = params.searchParcel;

    this.applySearch();
  }
  receiveClearFilter() {
    this.selectedCamera = '';
    this.selectedItemCode = '';
    this.dateRange = [];
    this.selectedUserForFilter = '';
    this.searchParcel = '';
    this.applySearch();
  }

  applySearch() {
    this.isLoading = true;
    const queryParams = new URLSearchParams();

    if (this.selectedCamera) {
      queryParams.set('captureDeviceId', this.selectedCamera);
    }

    if (this.selectedItemCode) {
      queryParams.set('itemCode', this.selectedItemCode);
    }

    if (this.dateRange && this.dateRange.length > 0) {
      const dateFrom = this.dateRange[0]?.getTime();
      const dateTo = this.dateRange[1]?.getTime();

      if (dateFrom && dateTo) {
        queryParams.set('dateFrom', dateFrom.toString());
        queryParams.set('dateTo', dateTo.toString());
      }
    }
    if (this.selectedUserForFilter) {
      queryParams.set('filterByUser', this.selectedUserForFilter);
    }
    if (this.searchParcel) {
      queryParams.set('itemId', this.searchParcel);
    }

    const serializedParams = queryParams.toString();
    const queryString = serializedParams ? `?${serializedParams}` : '';
    this.getAssigned(queryString);
  }

  onParcelAssigneeSelection(item: any = []) {

    const index = this.itemsFromSingleSelections.findIndex(parcel => parcel.itemId === item.itemId);

    if (index !== -1) {
      this.itemsFromSingleSelections[index] = item;
    } else {
      this.itemsFromSingleSelections.push(item);
    }
    this.itemsFromSingleSelections = this.itemsFromSingleSelections.filter(item => item.selectedUser);
  }

  onAssign() {
    let itemsToAssign = [];

    if (this.selectedParcel.length > 0 && !this.singleSelections) {
      itemsToAssign = this.selectedParcel;

    } else {
      itemsToAssign = this.itemsFromSingleSelections;

    }

    if (itemsToAssign.length > 0) {
      let parcels = itemsToAssign.slice(0, this.bulkUpdateLimit).map(item => ({
        itemId: item.itemId,
        userId: this.selectedParcel.length > 0 ? this.bulkUpdateUserId : item.selectedUser,
        status: "assigned",
        updater: this.updater,
        section: 'all_assigned'
      }));

      this.isLoading = true;

      this.parcelService.bulkAssignParcel(parcels).subscribe({
        next: () => {
          let message = (itemsToAssign.length > this.bulkUpdateLimit) ? `only first ${this.bulkUpdateLimit} selected` : parcels.length.toString();
          this.messageService.add({
            severity: 'success',
            summary: 'Row Submitted',
            detail: `Successfully submitted: ${message} rows`
          });
          this.isLoading = false;
          this.resetBulkId();
          this.applySearch();

        },
        error: (err) => {
          console.error(`Failed to bulk update`, err);
          this.isLoading = false;
        }
      });
    }
  }
  getToolTipFormattedText() {
    return (this.selectedParcel.length != 0 || this.itemsFromSingleSelections.length != 0) ? `${this.selectedParcel.length > 0 ? this.selectedParcel.length : this.itemsFromSingleSelections.length} of ${this.parcel.length} parcels selected to assign` : '';
  }
  onDelete(items: any[]) {
    this.parcelService.deleteItems(items).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: `${this.selectedParcel.length} Record deleted `
        });
        this.isLoading = false;
        this.resetBulkId();
        this.applySearch();

      },
      error: (err) => {
        console.error(`Failed to bulk update`, err);
        this.isLoading = false;
      }
    });
  }
  deleteConfirm(event: Event) {
    this.enableClose = true;
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: `Do you want to delete <b>${this.selectedParcel[0].itemId}</b> record?`,
      icon: 'pi pi pi-times-circle text-6xl text-red-500 mr-2',
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm button-bg',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm button-bg',
      accept: () => {
        this.isLoading = true;
        this.onDelete(this.selectedParcel)
      }
    });
  }
  checkSelection() {
    this.singleSelections = false;
    this.bulkUpdateUserId = this.selectedParcel.length == 0 ? '' : this.bulkUpdateUserId;
    if (this.selectedParcel.length > this.bulkUpdateLimit) {
      this.enableClose = false;
      this.confirmationService.confirm({
        header: 'Limit exceeded',
        message: `You've reached the assigning limit ${this.bulkUpdateLimit}`,
        icon: 'pi pi pi-exclamation-circle text-6xl text-primary-500 mr-4',
        acceptIcon: 'pi pi-check mr-2',
        acceptLabel: 'Ok',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        rejectVisible: false,
        closeOnEscape: false,

        accept: () => {
          this.selectedParcel = this.selectedParcel.slice(0, this.bulkUpdateLimit);
        }
      });
    }
  }
  onPageChange($event: TablePageEvent) {
    let prevRowsPerPage = this.bulkUpdateLimit
    this.bulkUpdateLimit = $event.rows
    if (this.bulkUpdateLimit < prevRowsPerPage)
      this.checkSelection()
  }

  
  onUndo() {
    const queryParams = {
      itemId: this.undoParcelDetails.itemId,
      userId:  this.undoParcelDetails.oldUserId,
      status: this.undoParcelDetails.oldStatus,
      updater: this.updater,
    }
    this.messageService.clear('actionToast');
    this.parcelService.updateParcelAssigned(queryParams).subscribe({
      next: (response) => {
        let msg = 'Item Status has been reverted successfully';
        let severity = 'success';
        let summary = 'Undo Successful'
        this.messageService.add({ severity, summary, detail: msg });
        this.closeToast();
      },
      error: (error) => {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Failed to handle item. Try again later' });
        this.closeToast();
      }
    })
    this.applySearch();
  }
  startCountdown() {
    this.timerId = setInterval(() => {
      if (this.timeLeft > 1) {
        this.timeLeft--;
      } else {
        this.closeToast();
      }
    }, 1000);
  }


  closeToast() {
    this.applySearch();
    this.clearTimer();
    this.messageService.clear('actionToast');
    
  
  }
  clearTimer() {
    clearInterval(this.timerId);
    this.timeLeft = this.INITIAL_TIME;
  }

  ngOnDestroy() {
    this.clearTimer();
  }


}
